import { zodResolver } from '@hookform/resolvers/zod'
import { EBonusMaxBet } from '@lbs/shared-rp-types'
import { useForm } from 'react-hook-form'
import { rpBonusFormSchema, TRpBonusFormData } from './schema'

export const useRpBonusForm = (defaultValues?: Partial<TRpBonusFormData>) => {
  return useForm<TRpBonusFormData>({
    resolver: zodResolver(rpBonusFormSchema),
    defaultValues: {
      name: '',
      min: 1,
      maxPayout: undefined,
      payouts: [],
      max: EBonusMaxBet.NO_LIMIT,
      ...defaultValues,
    },
    mode: 'onChange',
  })
}
